export const START_OF_WEEK = 1;
export const START_OF_DAY = '00:00:00';
export const END_OF_DAY = '24:00:00';
export const defaultTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone ?? 'Europe/Berlin';
